<app-action-button-with-embedded-spinner [actionObservable]="updateProcessPerformanceStatistic.bind(this)"
    [icon]="'replay'" [hint]="'Update Process Performance Statistic'"></app-action-button-with-embedded-spinner>
